import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Autocomplete, Box, Grid, Tab, TextField } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import CommonTable from 'components/commonTable/CommonTable';
import CommonBreadCrumb from 'components/commonBreadCrumb/CommonBreadCrumb';
import AllotDialog from 'components/allotDialog/AllotDialog';
import { getRequestVehicle, updateAssignVehicle } from 'redux/actions/UserAllot';
import { getAssignDriver } from 'redux/actions/UserTrip';
import Loader from 'components/loader/Loader';
import { handlePermissions } from 'utils/utils';
import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';
import LocationDropdown from 'components/LocationDropdown/LocationDropdown';

function AssignVechileView() {
  const dispatch = useDispatch();
  const id = localStorage.getItem('companyId')
  const userId = localStorage.getItem('ID')

  const [value, setValue] = useState('requested');
  const [openDialog, setOpenDialog] = useState(false);
  const [vehicleId, setVehicleId] = useState('')
  const driverData = useSelector((state) => state?.userDriver?.userDriver?.data)
  const assignDriverData = useSelector((state) => state?.userAssignDriver?.userAssignDriver?.data)
  const assignDriverLoader = useSelector((state) => state?.userAssignDriver?.loading)
  const tableData = useSelector((state) => state?.userRequestVehicle?.userRequestVehicle?.data)
  const loader = useSelector((state) => state?.userRequestVehicle?.loading)
  const [searchQuery, setSearchQuery] = useState("");
  const [filterDrivers, setFilterDrivers] = useState(assignDriverData)
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const selectedLocation = useSelector((state) => state?.locationDropdown?.selectedLocation);


  useEffect(() => {
    if (selectedLocation?.id) {
      dispatch(getRequestVehicle({ ...filterData, location: selectedLocation?.id }));
    }
  }, [selectedLocation?.id, value, page, rowsPerPage]);

  let filterData = {
    assignId: id,
    status: "",
    page: page,
    pageSize: rowsPerPage,
    type: value,
    location: selectedLocation?.id || ''
  }
  let filterDataDriver = {
    assignId: userId,
    status: "",
    page: "",
    pageSize: "",
    type: 'assignVehicle',
    location: selectedLocation?.id || ''
  }

  useEffect(() => {
    setFilterDrivers(assignDriverData)
  }, [assignDriverData])



  useEffect(() => {
    dispatch(getRequestVehicle(filterData));
  }, []);

  useEffect(() => {
    filterAllDrivers()
  }, [searchQuery])

  const onClickTableVendor = (data) => {
    setVehicleId(data?.id)
    dispatch(getAssignDriver({ vehicleId: data?.id }));
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setPage(0);
    filterData = { ...filterData, type: newValue, page: 0, location:  selectedLocation?.id }
    dispatch(getRequestVehicle(filterData));
  };

  const submittAssign = (data) => {
    const val = {
      vehicleId: vehicleId,
      driverId: data?.id,
      type: value,
      driverData: filterDataDriver
    }
    dispatch(updateAssignVehicle(val));
    handleClose();
  }

  const breadcrumbPaths = [
    { name: 'Assign Vehicle', url: '', className: 'colorBlue' },
  ];

  const handelSearch = (val) => {
    setSearchQuery(val)
  }
  const onClickMoreIcon = (data, type) => {
    if (type?.toLowerCase() == 'reassign') {
      setVehicleId(data?.id);
      dispatch(getAssignDriver({ vehicleId: data?.id }));
      setOpenDialog(true);
    }
    else {
      const val = {
        vehicleId: data?.id,
        driverId: '',
        type: value,
        driverData: filterData,
        unAssined: 'unAssined'
      }
      dispatch(updateAssignVehicle(val))
    }

  }

  const filterAllDrivers = () => {
    let filteredDriverList = [];

    if (searchQuery !== "") {
      filteredDriverList = assignDriverData.filter(driver => driver.driverName.toLowerCase().includes(searchQuery?.toLowerCase()))
    } else {
      filteredDriverList = assignDriverData
    }

    setFilterDrivers(filteredDriverList)

  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
    filterData = { ...filterData, page: newPage }
    dispatch(getRequestVehicle(filterData))
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    filterData = { ...filterData, page: 0, pageSize: parseInt(event.target.value) }
    dispatch(getRequestVehicle(filterData))
  }

  //roles and permissions
  const roleAndPermissions = useSelector(
    (state) => state?.getRolesAndPermissions?.rolesAndPermissions
  );
  const assignRoleEnum =
    roleAndPermissionEnum.assign;

  const accessForAll = handlePermissions(
    roleAndPermissions,
    assignRoleEnum.moduleKey,
    { defaultAllAccess: assignRoleEnum?.subModules?.assignVehicle?.all }
  );

  const accessForAssign = handlePermissions(
    roleAndPermissions,
    assignRoleEnum.moduleKey,
    { customAccess: assignRoleEnum?.subModules?.assignVehicle?.allot }
  );

  const assignBtnAccess = (accessForAll || accessForAssign);

  return (
    <div>
      <CommonBreadCrumb paths={breadcrumbPaths} />
      {loader ?
        <Loader />
        :
        <Grid container>
          <Grid item className="tableContainer" xs={12}>
            <Box className="contentBoxStyle">
              <TabContext value={value}>
                <Grid
                  container
                  className="tabBoxStyle"
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Grid item>
                    <TabList
                      className='minHeight32'
                      onChange={handleChange}
                      aria-label="lab API tabs example"
                      TabIndicatorProps={{
                        style: { backgroundColor: 'white' }, // Replace 'none' with your desired color
                      }}
                    >
                      <Tab label="Request" value="requested" className="tabStyle" />
                      <Tab label="Assigned" value="assigned" className="tabStyle" />
                    </TabList>
                  </Grid>
                  <Grid item xs={2} className="filter_menu">
                    <LocationDropdown
                      className="location-dropdown"
                    />
                  </Grid>
                </Grid>

                <TabPanel
                  value="requested"
                  className="vendotTable width100"
                >
                  <CommonTable
                    data={tableData}
                    onClickTableVendor={onClickTableVendor}
                    actionBtn="true"
                    handleClose={handleClose}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    isClickable={false}
                    assignBtnAccess={assignBtnAccess}
                  />
                </TabPanel>
                <TabPanel value="assigned" className="vendotTable">
                  <CommonTable
                    data={tableData}
                    onClickTableVendor={onClickTableVendor}
                    actionBtn="true"
                    handleClose={handleClose}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    isClickable={false}
                    tabName={'unAssignTab'}
                    onClickMoreIcon={onClickMoreIcon}
                    assignBtnAccess={assignBtnAccess}
                    viewMoreIcon={!assignBtnAccess}
                  />
                </TabPanel>
              </TabContext>
            </Box>
          </Grid>
        </Grid>}
      {openDialog && (
        <AllotDialog
          onSearch={handelSearch}
          type={"vechileView"}
          openDialog={openDialog}
          allotData={filterDrivers}
          title={'Available'}
          titleType={'Driver'}
          placeholder={'Search Driver'}
          handleClose={handleClose}
          submittAssign={submittAssign}
          loader={assignDriverLoader}
        />
      )}
    </div>
  );
}

export default AssignVechileView;
